const lowerbody1_week2 = [
  {
    name: "Leg Press",
    details: "Machine",
    sets: [
      { load: "165", reps: 15, rir: 3, rest: "60s" },
      { load: "185", reps: 15, rir: 3, rest: "60s" },
      { load: "205", reps: 15, rir: 3, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Push through your heels.",
  },
  {
    name: "Single Leg, Lying, Eccentric Hamstring Curl",
    details: "Machine",
    sets: [
      { load: "17", reps: 15, rir: 3, rest: "60s" },
      { load: "17", reps: 20, rir: 3, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Engage your glutes throughout the movement. Add tempo to exercise.",
  },
  {
    name: "Glute Drive",
    details: "Machine",
    sets: [
      { load: "95", reps: 15, rir: 3, rest: "60s" },
      { load: "95", reps: 15, rir: 3, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Hold at the top for 2 seconds.",
  },
  {
    name: "Standing Side Cable Abduction",
    details: "Cable Machine",
    sets: [
      { load: 12, reps: 15, rir: 3, rest: "60s" },
      { load: 12, reps: 15, rir: 3, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Keep your upper body steady.",
  },
  {
    name: "Seated Adductor Machine",
    details: "Machine",
    sets: [
      { load: "145", reps: 15, rir: 3, rest: "60s" },
      { load: "160", reps: 15, rir: 3, rest: "60s" },
      { load: "160", reps: 15, rir: 3, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Control the movement both ways. Add stimulus algorithm.",
  },
];

export default lowerbody1_week2;
